import * as React from 'react';
import {
  offsetTop,
  currentUrl,
  scrollTo,
  useMatchLargeViewport,
  pageRenderingDoneSignal,
  HistoryEventType,
} from '@avensia/excite';
import { DESKTOP_HEADER_HEIGHT_WITH_BANNER, HEADER_HEIGHT } from 'webapp/utils/constants';

const URL_PARAM_SCROLL = 'scroll';

export function useContentScroll<T extends HTMLElement>() {
  const isLargeViewport = useMatchLargeViewport();
  const topContentRef = React.useRef<T>(null);
  const bottomContentRef = React.useRef<T>(null);
  const scrollParam = Number(currentUrl().searchParams.get(URL_PARAM_SCROLL) ?? '0');

  React.useEffect(() => {
    if (isNaN(scrollParam) || scrollParam < 1 || scrollParam > 2) {
      return;
    }

    const activeContentRef = scrollParam === 1 ? topContentRef : bottomContentRef;

    if (window.CookieInformation && window.CookieInformation.wasBannerShown()) {
      window.addEventListener(
        'CookieInformationConsentGiven',
        function () {
          scrollToContent(activeContentRef, isLargeViewport);
        },
        false,
      );
    }

    pageRenderingDoneSignal.on(event => {
      if (event.event === HistoryEventType.Push && !event.url.searchParams.has('p')) {
        scrollToContent(activeContentRef, isLargeViewport);
      }
    });

    scrollToContent(activeContentRef, isLargeViewport);
  }, [isLargeViewport, scrollParam]);

  return { topContentRef, bottomContentRef };
}

function scrollToContent(contentRef: React.RefObject<HTMLElement | null>, isLargeViewport: boolean) {
  const headerHeight = isLargeViewport ? DESKTOP_HEADER_HEIGHT_WITH_BANNER - 30 : HEADER_HEIGHT;

  if (contentRef && contentRef.current) {
    scrollTo(offsetTop(contentRef.current) - headerHeight);
  }
}
